const mediaItems = [
  {
    title: '偶像练习生特辑',
    desc: '最新偶像练习生舞台直拍合集，高清呈现每个精彩瞬间',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20modern%20variety%20show%20stage%20with%20young%20performers%20dancing%20in%20colorful%20stage%20costumes%2C%20warm%20spotlight%20beams%20in%20coral%20and%20golden%20tones%2C%20minimalist%20clean%20background%2C%20entertainment%20broadcasting%20theme%2C%20soft%20gradient%20atmosphere&width=600&height=400&seq=media-01&orientation=landscape',
    tag: '热门',
  },
  {
    title: '户外挑战真人秀',
    desc: '偶像团体户外生存挑战全程记录，紧张刺激不容错过',
    img: 'https://readdy.ai/api/search-image?query=Flat%20design%20illustration%20of%20outdoor%20adventure%20reality%20show%20scene%20with%20abstract%20mountain%20landscape%20and%20warm%20sunset%20colors%2C%20silhouettes%20of%20people%20doing%20challenges%2C%20minimalist%20style%2C%20golden%20and%20coral%20tones%2C%20clean%20geometric%20shapes&width=600&height=400&seq=media-02&orientation=landscape',
    tag: '新番',
  },
  {
    title: '音乐舞台纯享版',
    desc: '爱豆团体最新打歌舞台纯享版，沉浸式音乐体验',
    img: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20illustration%20of%20music%20performance%20stage%20with%20colorful%20concert%20lighting%2C%20abstract%20sound%20wave%20patterns%20in%20warm%20coral%20and%20amber%20gradients%2C%20clean%20theatrical%20atmosphere%2C%20modern%20entertainment%20design%2C%20soft%20glowing%20effects&width=600&height=400&seq=media-03&orientation=landscape',
    tag: '精选',
  },
  {
    title: '旅行综艺全记录',
    desc: '跟随爱豆的脚步游遍世界，治愈系旅行综艺合集',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20illustration%20of%20travel%20adventure%20with%20abstract%20landmark%20silhouettes%2C%20warm%20golden%20hour%20lighting%2C%20minimalist%20geometric%20style%2C%20travel%20and%20exploration%20theme%2C%20soft%20peach%20and%20coral%20color%20palette%2C%20clean%20composition&width=600&height=400&seq=media-04&orientation=landscape',
    tag: '治愈',
  },
  {
    title: '幕后独家花絮',
    desc: '偶像团体综艺拍摄现场的独家探班花絮，近距离了解爱豆日常',
    img: 'https://readdy.ai/api/search-image?query=Flat%20design%20illustration%20of%20behind%20the%20scenes%20TV%20production%20set%20with%20cameras%20and%20warm%20studio%20lighting%2C%20minimalist%20style%2C%20abstract%20film%20equipment%20silhouettes%2C%20coral%20and%20golden%20tones%2C%20clean%20entertainment%20industry%20atmosphere&width=600&height=400&seq=media-05&orientation=landscape',
    tag: '独家',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          精彩看点
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选偶像综艺热门看点，高清流畅不卡顿
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-all"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`爱豆影视 - ${item.title}`}
                  title={`爱豆影视${item.title}高清在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-1.5 whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}